import * as VIP from "@/constant/VIP"
import {
  PERSON_VIP_INFO,
  BUSINESS_VIP_INFO, BUSINESS_VIP_MONTH_INFO
} from "~/constant/VIP";
// import {businessVipWithMonth, businessVipWithYear, personVipWithYear} from "@/constant/VIP";

export const packageList = [
  /* 个人商用VIP */
  {
    headline: "商用VIP",
    id: 2,
    price: 299,
    advantageList: [
      {
        title: "个人商用授权",
        isGou: true
      },
      {
        title: "永久商用授权",
        isGou: true
      },
      {
        title: "每天内容更新",
        isGou: true
      },
      {
        title: "全站不限下载",
        isGou: true
      },
      {
        title: "无限高速下载",
        isGou: true
      },
      {
        title: "高级搜索",
        isGou: true
      },
      {
        title: "无广告浏览",
        isGou: true
      }
    ]
  },
  /* 个人下载VIP */
  {
    headline: "下载VIP",
    id: 1,
    price: 199,
    advantageList: [
      {
        title: "个人商用授权",
        isGou: false
      },
      {
        title: "永久商用授权",
        isGou: false
      },
      {
        title: "每天内容更新",
        isGou: true
      },
      {
        title: "全站不限下载",
        isGou: true
      },
      {
        title: "无限高速下载",
        isGou: true
      },
      {
        title: "高级搜索",
        isGou: true
      },
      {
        title: "无广告浏览",
        isGou: false
      }
    ]
  },
]

export const info = {

  /* 权益保障 */
  rightsAndInterests: {
    list: [
      {
        name: '',
        desc: '商用授权：商用授杈对象',
      },
      {
        name: '',
        desc: '授权期限：永久商用授权',
      },
      {
        name: '',
        desc: '内容下载：每天内容更新，作品高速下载',
      },
      {
        name: '',
        desc: '下载限制：海量正版图片，尊享版权授权',
      },
      {
        name: '',
        desc: '版权保障：全站素材下载，版权保障无忧',
      },
      {
        name: '',
        desc: '在线开票：官方正规发票，在线即可申请',
      }
    ]
  },
  /* 线上用途 */
  onlineUse: {
    list: [
      {
        name: '',
        desc: '新媒体用途：微博、微信、小红书、今日头条、知乎等新媒体平台',
      },
      {
        name: '',
        desc: '电商用途：淘宝、天猫、京东、拼多多、抖音、美团、饿了么、小红书等电商交易平台用图',
      },
      {
        name: '',
        desc: '企业办公：VI设计、营销策划方案、商业提案、项目计划书、年度报告等配图（非转授权）',
      },
    ]
  },

  /* 线下用途 */
  advertising: {
    list: [
      {
        name: '',
        desc: '网络宣传推广：官方网站、H5、APP、小程序、百度、360等宣传配图使用',
      },

      {
        name: '',
        desc: '流媒体平台宣传：B站、抖音、快手、腾讯视频、爱奇艺、优酷等媒体播放平台广告宣传',
      },
      {
        name: '',
        desc: '户外广告：楼宇、车身、灯箱、围挡、橱窗、户外广告牌、公共场所陈列',
      },
    ]
  },

  /* 线下用途 */
  offlineUse: {
    list: [
      {
        name: '',
        desc: `物料印刷：海报、宣传单、易拉宝、宣传画册、优惠券、会员卡等宣传物料 <br/> 线下活动：公司年会、颁奖活动、启动仪式、演出、展会、发布会等线下活动背景及屏幕`,
      },

      {
        name: '',
        desc: '影视制作：电影、电视剧、新闻、纪录片、微电影、自制剧、广播等制作使用',
      },
      {
        name: '',
        desc: `
          电子出版物：电子图书类、电子期刊类、电子报纸等 <br/>
          实物印刷： 图书、期刊、杂志、报纸等 <br/>
          商品生产：产品外包装、服装服饰、艺术品、工艺品（装饰画、手机壳、贺卡、明信片、日历、杯子）等实物商品及赠品 <br/>
        `,
      },
      {
        name: '',
        desc: '产品内置：软件主题/皮肤/背景、软件内置、H5应用、小程序、网络课程、付费音视频、游戏内置、智能硬件等',
      },
      {
        name: '',
        desc: '其他用途：其他使用范围',
      }
    ]
  },

  /* 商用VIP */
  businessInfo: BUSINESS_VIP_INFO,
  /* 下载VIP */
  personInfo: PERSON_VIP_INFO,
  /* 商用VIP包月 */
  businessMonthInfo: BUSINESS_VIP_MONTH_INFO
}
